import { useCallback, useEffect, useState } from 'react';
import {
  probeSeqaiAvailability,
  SeqaiAvailability,
  SEQAI_API_BASE_URL,
} from '../config/seqai';

export function useSeqaiAvailability(refreshKey = 0) {
  const [availability, setAvailability] = useState<SeqaiAvailability>({
    status: 'checking',
  });

  const refresh = useCallback(async () => {
    setAvailability({ status: 'checking' });
    const result = await probeSeqaiAvailability();
    setAvailability(result);
  }, []);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const result = await probeSeqaiAvailability();
      if (!cancelled) setAvailability(result);
    })();
    return () => {
      cancelled = true;
    };
  }, [refreshKey]);

  return {
    availability,
    apiUrl: SEQAI_API_BASE_URL,
    isAllowed: availability.status === 'allowed',
    isChecking: availability.status === 'checking',
    isBlocked: availability.status === 'blocked',
    refresh,
  };
}
